module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-left-top-backplates-remnants.eb84518c.png";